import angular from "angular"
import React from "react"
import { react2angular } from "react2angular"
import Modal from "@paprika/modal"

function HomePanelModal(props) {
  const [isModalOpen, setIsModalOpen] = React.useState(true)
  const hasWelcomeModalBeenSeen = sessionStorage.getItem("hasWelcomeModalBeenSeen")

  let mounted = true
  React.useEffect(() => {
    if (!hasWelcomeModalBeenSeen && mounted) {
      sessionStorage.setItem("hasWelcomeModalBeenSeen", true)
    }
    return function cleanup() {
      mounted = false
    }
  }, [hasWelcomeModalBeenSeen])

  return (
    <div className="home-panel-modal">
      {!hasWelcomeModalBeenSeen ? (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} size="large">
          <Modal.Header />
          <Modal.Content>
            <img id="logo" src={`assets/logos/${props.logoUrl}.png`} alt={props.title} />
            <p
              className="title"
              dangerouslySetInnerHTML={{
                __html: props.title,
              }}
            ></p>
            <p
              className="description"
              dangerouslySetInnerHTML={{
                __html: props.description,
              }}
            ></p>
          </Modal.Content>
        </Modal>
      ) : null}
    </div>
  )
}

export default angular
  .module("makeamapAngularApp.homepanelmodal", [])
  .component("homepanelmodal", react2angular(HomePanelModal, ["logoUrl", "title", "description"])).name
